export default class AppMediaFlag {
    constructor () {
        this.init();
    }

    init () {
        $('[data-toggle=mediaflag]').on('click', function (e) {
            e.preventDefault();
            let $flag = $(this);
            let mediaId = $flag.attr('data-media-id');
            let flag = $flag.attr('data-flag');
            let $flags = $('[data-toggle=mediaflag][data-media-id=' + mediaId + '][data-flag=' + flag + ']');

            $.post($flag.attr('data-url'), {
                state: !$flag.data('flag-state') ? 1 : 0,
            })
                .done(function (response) {
                    let state = response.custom_properties.flags[flag];
                    $flags.data('flag-state', state);
                    let $icon = $flags.find('i');
                    $icon
                        .removeClass('fas')
                        .removeClass('far')
                        .addClass(state ? 'fas' : 'far')
                    ;

                    $flag.parents('[data-toggle=customerfilter]').trigger('render.filter');
                });
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/mediaFlag.js